module.exports = __webpack_public_path__ + "static/media/landingpage_auto.08f2e23e.png";